module.exports = __webpack_public_path__ + "static/img/Frame 18218.9e10b00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/swiper3/Frame 18218.png
// module id = TKJc
// module chunks = 12